import React from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
//import StatsPanel from '../../components/admin/StatsPanel';
import QuickActions from '../../components/admin/QuickActions';
import RecentOrders from '../../components/admin/RecentOrders';
import styles from './Dashboard.module.css';

const AdminDashboard = () => {
  
  return (
    <AdminLayout>
      <div className={styles.dashboard}>
        <div className={styles.header}>
          <h1>Panel de Administración</h1>
          <p>Bienvenido de vuelta, Administrador</p>
        </div>

       {/* <StatsPanel />*/}
        
        <div className={styles.grid}>
          <div className={styles.column}>
            <QuickActions />
          </div>
          <div className={styles.column}>
            <RecentOrders />
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;